import { Component } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { Router } from '@angular/router';
import { AuthService } from '../../services/auth.service';
import { RouterModule } from '@angular/router';
import { firstValueFrom } from 'rxjs';

@Component({
  selector: 'app-login',
  standalone: true,
  templateUrl: './login.component.html',
  styleUrls: ['./login.component.scss'],
  imports: [
    CommonModule,
    FormsModule,
    RouterModule
  ]
})
export class LoginComponent {
  email = '';
  password = '';
  loading = false;

  constructor(private auth: AuthService, private router: Router) {}

  async login() {
    this.loading = true;
    try {
      await this.auth.login(this.email, this.password);

    const user = await this.auth.waitForUser();

    if (!user) {
      throw new Error('Unable to load user profile.');
    }
    const role = user?.role ?? 'tenant';
      switch (role) {
        case 'admin':
          this.router.navigate(['/admin']);
          break;
      
        case 'manager':
          this.router.navigate(['/admin/applications']);
          break;
      
        default:
          this.router.navigate(['/tenant']);
      }
    } catch (err) {
      alert('Login failed: ' + (err as Error).message);
    } finally {
      this.loading = false;
    }
  }
async loginWithGoogle() {
  this.loading = true;

  try {
    const result = await this.auth.loginWithGoogle();

    if (result === 'NEW_USER') {
      this.router.navigate(['/register']);
      return;
    }

    const user = await firstValueFrom(this.auth.user$);
    const role = user?.role ??'tenant';

    switch (role) {
      case 'admin':
        this.router.navigate(['/admin']);
        break;

      case 'manager':
        this.router.navigate(['/admin/applications']);
        break;

      default:
        this.router.navigate(['/tenant']);
    }
  }
  catch{
    console.log(console.error());
  }
}

}